import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "my-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackPage = _resolveComponent("BackPage")!
  const _component_Upload = _resolveComponent("Upload")!
  const _component_Layout = _resolveComponent("Layout")!

  return (_openBlock(), _createBlock(_component_Layout, {
    removePadding: false,
    disableTopNav: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_BackPage, {
          title: _ctx.$t('New Post')
        }, null, 8, ["title"]),
        _createVNode(_component_Upload)
      ])
    ]),
    _: 1
  }))
}